import React, { memo } from 'react';

import MuiButton from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { withStyles } from '@material-ui/core/styles';
import { blueBorderColor, greyBorderColor, lightBlueColor, lightGreyColor } from '../../utils/colors';

const StyledButton = withStyles((theme) => ({
  root: {
    width: (props) => props?.width ? props.width : '25px',
    minWidth: (props) => props?.width ? props.width : '25px',
    height: (props) => props?.height ? props.height : '25px',
    borderRadius: '50%',
    textTransform: 'none',
    fontSize: '14px',
    fontWeight: 'bold',
    border: theme.palette.type === 'dark' ? `1px solid ${theme.palette.primary.main}` : `1px solid ${blueBorderColor}`,
    background: theme.palette.type === 'dark' ? theme.palette.secondary.light : lightBlueColor,
    color: theme.palette.type === 'dark' ? theme.palette.primary.main : blueBorderColor,
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.paper : lightBlueColor,
    },
    '&:active': {
      backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.paper : lightBlueColor,
    },
    '&:focus': {
      backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.paper : lightBlueColor,
    },
    '&:disabled': {
      backgroundColor: theme.palette.type === 'dark' ? theme.palette.action.disabledBackground : lightGreyColor,
      borderColor: theme.palette.type === 'dark' ? theme.palette.action.disabledBackground : greyBorderColor,
      color: theme.palette.type === 'dark' ? theme.palette.action.disabled : greyBorderColor
    }
  }
}))(MuiButton);

const AddButton = (props) => {
  const {
    onClick,
    disabled,
    width = 25,
    height = 25,
    variant = 'add',
  } = props;

  return (
    <StyledButton
      onClick={onClick}
      disabled={disabled}
      width={width}
      height={height}
    >
      {variant === 'remove' ? (
        <RemoveIcon fontSize='small' />
      ) : (
        <AddIcon fontSize='small' />
      )}
    </StyledButton>
  );
};

export default memo(AddButton);
